import script from "./DisputeManager.vue?vue&type=script&setup=true&lang=js"
export * from "./DisputeManager.vue?vue&type=script&setup=true&lang=js"

import "./DisputeManager.vue?vue&type=style&index=0&id=51e3eeae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51e3eeae"]])

export default __exports__